import { useState, useCallback } from "react";
import { getAssets } from "../../api/get/get-malware";
import {
  postMalUrl,
  postMalFile,
} from "../../api/post/post-malware";
import { useAuth } from "../../context/contextAuth";

const useMalwareData = () => {
  const { userId } = useAuth();
  const [activeView, setActiveView] = useState("CARD");
  const [malScanLoading, setMalScanLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabResult, setActiveTabResult] = useState("Detection");
  const [response, setResponse] = useState(null);
  const [malAssets, setMalAssets] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState(null);
  const [duration, setDuration] = useState("Last 28 days");
  const [url, setUrl] = useState("");
  const [search, setSearch] = useState("");
  const [file, setFile] = useState(null);

  const initData = useCallback(async () => {
    if (!userId) {
      resetState();
      return;
    }
    try {
      const data = await getAssets(userId);
      const assets = data || [];
      setMalAssets(assets);

      if (assets.length > 0) {
        setActiveView("GRAPH");
      } else {
        setActiveView("CARD");
      }
    } catch (err) {
      console.error("Error fetching malware assets:", err);
      setMalAssets([]);
      setActiveView("CARD");
    }
  }, [userId]);

  const handleUrlScan = async () => {
    setMalScanLoading(true);
    setError(null);
    try {
      const res = await postMalUrl(userId, url);
      setResponse(res.data);
      const updatedData = await getAssets(userId);
      setMalAssets(updatedData || []);
      setActiveView("VIEW");
    } catch (err) {
      setError(err.message);
      setActiveView("CARD");
    } finally {
      setMalScanLoading(false);
      setUrl("");
    }
  };

  const handleFileScan = async (selectedFile) => {
    if (!selectedFile) return;
    setMalScanLoading(true);
    setError(null);
    try {
      const res = await postMalFile(userId, selectedFile);
      setResponse(res.data);
      const updatedData = await getAssets(userId);
      setMalAssets(updatedData || []);
      setActiveView("VIEW");
    } catch (err) {
      console.error("❌ File Malware Scanning Error:", err);
      setError(err.message || "An unexpected error occurred.");
      setActiveView("CARD");
    } finally {
      setMalScanLoading(false);
    }
  };

  const handleSearchScan = async () => {
    // function logic                                          
  };

  const handleClickResult = useCallback((tab) => {
    setActiveTabResult(tab);
  }, []);

  const resetState = () => {
    setActiveView("CARD");
    setResponse(null);
    setMalScanLoading(false);
    setMalAssets([]);
    setUrl("");
    setSearch("");
    setFile(null);
    setError(null);
    setActiveTab(1);
    setActiveTabResult("Detection");
    setDuration("Last 28 days");
    setCurrentIndex(0);
  };

  return {
    // UI State
    activeView,
    setActiveView,
    malScanLoading,
    activeTab,
    setActiveTab,
    activeTabResult,
    setActiveTabResult,
    duration,
    setDuration,
    currentIndex,
    setCurrentIndex,

    // Data
    malAssets,
    response,
    setResponse,
    error,

    // Form Inputs
    url,
    setUrl,
    search,
    setSearch,
    file,
    setFile,

    // Actions
    initData,
    handleUrlScan,
    handleFileScan,
    handleSearchScan,
    handleClickResult,
    resetState,
  };
};

export default useMalwareData;
